/* eslint-disable no-undef */
import { API } from 'aws-amplify';

export function getGuides() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/city-guides');
}

export function putGuide(guide) {
  return API.put('party', '/city-guides', { body: { ...guide } });
}

export function deleteGuide(guideId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.del('party', `/city-guides/${guideId}`);
}

export function getEntertainments() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/city-guides-entertainments');
}

export function putEntertainment(entertainment) {
  return API.put('party', '/city-guides-entertainments', {
    body: { ...entertainment },
  });
}

export function deleteEntertainment(entertainmentId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.del('party', `/city-guides-entertainments/${entertainmentId}`);
}

export function getUrlForImage(type) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/city-guides/get-signed-url/${type}`);
}

export function getUrlForImageById(type, id) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/city-guides/get-signed-url/${type}/${id}`);
}
